import { Identity } from "@sdbn/appclient";

export class TransportStationAssignment {
    transport: Identity;
    station: Identity;
  }
